import './GamesDescriptor.css';
import './pixelcorner.css';

// TODO: do this differently from other descriptors
const GamesDescriptor = ({ label, code, playLink, icon, screenshots, children }) => (
  <fieldset className="GameDescriptor pixel-corners" key={label}>
    <legend>{label} <img src={icon} alt={icon}/></legend>
    <a href={code}>Source Code</a>
    <a href={playLink}>Play the game</a>
    <div className="Screenshots">
      {screenshots.map((screenshot, i) => (
        <img src={screenshot} alt={`Screenshot ${i+1} of ${label}`} key={screenshot} />
      ))}
    </div>
    {children}
  </fieldset>
);

export default GamesDescriptor;
